










































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';

import { Edit2Icon, MoreVerticalIcon, TrashIcon } from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';
import ProductStatusBadge from '@/components/common/ProductStatusBadge.vue';
import { ITag, TagCategory } from 'admiral-core';
import { TagApi } from '@/services/TagApi';

@Component({
  name: 'agency-tags-settings',
  components: {
    ProductStatusBadge,
    Avatar,
    UserStatusBadge,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
  },
})
class AgencyTagsSettings extends mixins(BaseMixin) {
  tags: ITag[] = [];

  async mounted() {
    await this.loadTags();
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        agency: this.agency,
      });

      this.tags = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  async onDeleteTag(tag: ITag) {
    try {
      await TagApi.delete({
        tag,
      });
      await this.loadTags();
    } catch (e) {
      this.$toastr.e(
        'Beim Löschen des Tags ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
  }

  getCategoryLabel(tag: ITag) {
    switch (tag.category) {
      case TagCategory.Policies:
        return 'Anbahnungen';
      case TagCategory.Tasks:
        return 'Aufgaben';
      case TagCategory.Damages:
        return 'Schäden';
      case TagCategory.Customers:
        return 'Kunden';
      default:
        return 'Aufgaben';
    }
  }
}

export default AgencyTagsSettings;
